import { render, staticRenderFns } from "./HeadlineWithText.vue?vue&type=template&id=64779476&"
import script from "./HeadlineWithText.vue?vue&type=script&lang=js&"
export * from "./HeadlineWithText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SectionBaseSection: require('/usr/src/app/components/sections/BaseSection.vue').default})
